import CategoriesTab from './CategoriesTab'
export default CategoriesTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/HWTab/MappingTabs/CategoriesTab/index.js